import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { LegacyBaseApiService } from '@smartera/core';

//TODO: remove

@Injectable({
	providedIn: 'root',
})
export class StockSetService extends LegacyBaseApiService<any> {
	override get apiUrl() {
		return `${Urls.BASE_URL}/main/sets`;
	}

	findPrice(
		setMstId: string,
		args: any = {
			quantity: 1,
		}
	) {
		return this._restClientService.post(
			`${this.apiUrl}/${setMstId}/find-price`,
			JSON.stringify({
				itemId: setMstId,
				...args,
			})
		);
	}
}

@Injectable()
export class StockSetDetailService extends LegacyBaseApiService<any> {
	public stoclSetMasterId: string;

	override get apiUrl(): string {
		return `${Urls.BASE_URL}/main/sets/${this.stoclSetMasterId}/details`;
	}

	set _apiUrl(val: string) {}

	public getSkuDetial(skuId: string) {
		return this._restClientService.post(`${Urls.BASE_URL}/sku/sku/skus/${skuId}/details/get-or-create`, '{}');
	}
}
